module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-mobile-photo-168b7f1e913c6889d5c11209594d3750.jpg";